import React, { ReactNode } from 'react';
import styles from './assets/screen.module.scss';
import classNames from 'classnames';
import OrderRemainingHoursReportsGrid from './components/OrderRemainingHoursReportsGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import RoleLayout from 'src/components/layout/RoleLayout';
import { IOrderRemainingHoursReport } from 'src/types/orderRemainingHoursReport';
import user from '../../../../../services/user-auth';
import UserRole from '../../../../../enumerables/user-role';
import Loader from '../../../../../components/Loader';

export interface StateProps {
    data: Paginated<IOrderRemainingHoursReport>;
    inProgress: boolean;
    students: SelectObject[];
    districts: SelectObject[];
    vendors: SelectObject[];
    totals: any;
    serviceTypes: SelectObject[];
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getDataTotal: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
    getStudents: (params: QueryParams) => void;
    getDistricts: (params: QueryParams) => void;
    getVendors: (params: QueryParams) => void;
    clearTotal: () => void;
    getServiceTypes: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class OrderExpiredReportList extends React.Component<Props, { isTotal: boolean; filters: any }> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isTotal: false,
            filters: {},
        };
        this.getData = this.getData.bind(this);
    }

    componentDidMount() {
        this.props.getServiceTypes({
            page: 1,
        });
        this.props.getStudents({
            page: 1,
        });
    }

    componentWillUnmount() {
        this.setState({ isTotal: false });
        this.props.clearTotal();
    }

    getTotals() {
        this.props.getDataTotal({ page: 1, filters: this.state.filters });
        this.setState({ isTotal: true });
    }
    getData(data: any) {
        if (data.filters) {
            this.setState({ ...this.state, filters: data.filters });
        }
        if (!this.state.isTotal) {
            data.notTotal = true;
        }
        this.props.getData({ ...data, page: data.page ? data.page : 1 });
    }

    public render(): ReactNode {
        const { data, getData, students, districts, vendors, getDataCsv, serviceTypes, inProgress } = this.props;
        const isProvider = user.getRoles().includes(UserRole.ROLE_USER);
        const isSupervisor = user.getSupervisor();
        return (
            <RoleLayout>
                {isProvider && !isSupervisor ? null : <div className={'isGetCsv'}></div>}
                <div className={classNames(styles.pageHeading, 'pageHeading')}>
                    <h2 className={classNames(styles.headingTitle, 'pageHeadingTitle')}>
                        Orders Remaining Hours {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                    {!this.state.isTotal ? (
                        <button onClick={() => this.getTotals()} className={`btn btn-info`}>
                            Totals
                        </button>
                    ) : null}
                </div>
                {inProgress ? <Loader /> : null}
                <div className={classNames(styles.list)}>
                    <OrderRemainingHoursReportsGrid
                        students={students}
                        districts={districts}
                        getDataCsv={getDataCsv}
                        vendors={vendors}
                        data={data}
                        getData={this.getData}
                        serviceTypes={serviceTypes}
                    />
                </div>
            </RoleLayout>
        );
    }
}

export default OrderExpiredReportList;
